export default function arrayBufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer);
  const binary = String.fromCharCode.apply(null, bytes);
  return typeof window === "undefined"
    ? Buffer.from(binary, "binary").toString("base64")
    : btoa(binary);
}
